import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { useQuery, useQueryClient } from "react-query"
import WrappedAgTable from "../../../Components/Table/WrappedAgTable"
import { DeleteContratoSimil, EditMantenimientoTiendasEx, GetMantenimientoTiendasEx, ListaLocales, ListaLocalesEx, SaveMantenimientoTiendasEx } from "../../../api/Api";
import Tippy from "@tippyjs/react";
import ConfirmWithLoader from "../../../Components/Modals/ConfirmWithLoader";
import Select from 'react-select';
import "./ContratosSimiles.css"
import { Button, Card } from "react-bootstrap";
import Confirm from "../../../Components/Modals/Confirm";
import CardEx from "../../../Components/Cards/CardEx";
import cogoToast from "cogo-toast";

export default function ContratosSimiles() {
    const queryClient = useQueryClient();
    const gridApiRef = useRef(null);
    const { data: data_contratos_similes, refetch: refetch_data_data_contratos_similes } = useQuery("getDataContratosSimiles", () => GetMantenimientoTiendasEx());
    let { data: dataListaLocalesSantaAnita } = useQuery(
        "ListaLocalesSantaAnita",
        async () => await ListaLocalesEx(3)
    );

    let { data: dataListaLocalesArequipa } = useQuery(
        "ListaLocalesArequipa",
        async () => await ListaLocalesEx(2)
    );

    let { data: dataListaLocalesChiclayo } = useQuery(
        "ListaLocalesChiclayo",
        async () => await ListaLocalesEx(6)
    );

    let { data: dataListaLocalesIquitos } = useQuery(
        "ListaLocalesIquitos",
        async () => await ListaLocalesEx(7)
    );

    let { data: dataListaLocalesSjl } = useQuery(
        "ListaLocalesSjl",
        async () => await ListaLocalesEx(8)
    );

    const header = useMemo(() => [
        {
            headerName: 'Id',
            field: 'id',
            width: 80,
            pinned: 'left',
        },
        {
            headerName: 'Acciones',
            width: 100,
            filter: false,
            pinned: 'left',
            sortable: false,
            cellRenderer: (props) => props.data ? (
                <div className="d-flex align-items-center h-100">
                    <div className="d-flex align-items-center w-60p">
                        <Tippy theme='light-border' content="Editar">
                            <button className="btn btn-link garantias-font align-items-center d-flex h-100 justify-content-center mx-auto"
                                onClick={() => handleShowRecepcionModal(props.data)}>
                                {/* <i className="fi-rr-edit"text-success></i>
                                <i class="fi fi-rr-file-edit text-success"></i> 
                                <i class="fi fi-rr-pencil text-success "></i>
                                */}
                                <i className="fi-rr-edit text-success"></i>
                            </button>
                        </Tippy>
                    </div>
                    <div className="d-flex align-items-center w-60p">
                        <Tippy theme='light-border' content="Eliminar">
                            <button className="btn btn-link garantias-font align-items-center d-flex h-100 justify-content-center mx-auto"
                                onClick={() => handleShowModalDelete(props.data)}>
                                <i className="fi fi-rr-trash text-danger"></i>
                            </button>
                        </Tippy>
                    </div>
                </div>


            ) : <></>
        },
        {
            headerName: 'Arequipa',
            children: [
                {
                    headerName: 'Contrato',
                    field: 'contratoArequipa',
                    width: 120,
                },
                {
                    headerName: 'Denominación',
                    field: 'contratoArequipaDenominacion',
                    width: 180,
                },
            ]
        },
        {
            headerName: 'Santa Anita',
            children: [
                {
                    headerName: 'Contrato',
                    field: 'contratoSantaAnita',
                    width: 120,
                },
                {
                    headerName: 'Denominación',
                    field: 'contratoSantaAnitaDenominacion',
                    width: 180,
                },
            ]
        },
        {
            headerName: 'Chiclayo',
            children: [
                {
                    headerName: 'Chiclayo',
                    field: 'contratoChiclayo',
                    width: 120,
                },
                {
                    headerName: 'Denominación',
                    field: 'contratoChiclayoDenominacion',
                    width: 180,
                },
            ]
        },
        {
            headerName: 'Iquitos',
            children: [
                {
                    headerName: 'Contrato',
                    field: 'contratoIquitos',
                    width: 120,
                },
                {
                    headerName: 'Denominación',
                    field: 'contratoIquitosDenominacion',
                    width: 180,
                },
            ]
        },
        {
            headerName: 'San Juan de Lurigancho',
            children: [
                {
                    headerName: 'Contrato',
                    field: 'contratoSjl',
                    width: 120,
                },
                {
                    headerName: 'Denominación',
                    field: 'contratoSjlDenominacion',
                    width: 180,
                },
            ]
        },

    ]);

    const agGridLista = useMemo(() => ({
        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            minWidth: 10,
            //defaultMinWidth: 50,
            floatingFilter: true,
            // allow every column to be grouped
            enableRowGroup: true,

        },
        columnDefs: header,
        rowData: data_contratos_similes?.data.table,
        pagination: true,
        rowGroupPanelShow: 'never',
        rowSelection: 'single',
        // excelStyles: excelStylesGrid
        domLayout: "normal",
        onGridReady: (params) => {
            gridApiRef.current = params.api;
        },
    }), [header, data_contratos_similes?.data.table]);

    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [isLoadingUpdateModal, setIsLoadingUpdateModal] = useState(false);
    const [isFinishUpdateModal, setIsFinishUpdateModal] = useState(false);
    const [messageErrorSave, setMessageErrorSave] = useState("");

    const [idContratoSimil, setIdContratoSimil] = useState(null);
    const [selectedOptionArequipa, setSelectedOptionArequipa] = useState(null);
    const [selectedOptionSantaAnita, setSelectedOptionSantaAnita] = useState(null);
    const [selectedOptionChiclayo, setSelectedOptionChiclayo] = useState(null);
    const [selectedOptionIquitos, setSelectedOptionIquitos] = useState(null);
    const [selectedOptionSjl, setSelectedOptionSjl] = useState(null);

    const handleNewContratosSimil = useCallback((props) => {
        setIdContratoSimil(null);
        setSelectedOptionArequipa(null);
        setSelectedOptionSantaAnita(null);
        setSelectedOptionChiclayo(null);
        setSelectedOptionIquitos(null);
        setSelectedOptionSjl(null);
        setShowUpdateModal(true);
    }, [])

    const handleShowRecepcionModal = useCallback((props) => {

        setIdContratoSimil(props.id);

        const currentArequipa = dataListaLocalesArequipa?.data.find(i => i.value === props.contratoArequipa);
        setSelectedOptionArequipa(currentArequipa === undefined ? null : currentArequipa);

        const currentSantaAnita = dataListaLocalesSantaAnita?.data.find(i => i.value === props.contratoSantaAnita);
        setSelectedOptionSantaAnita(currentSantaAnita === undefined ? null : currentSantaAnita);

        const currentChiclayo = dataListaLocalesChiclayo?.data.find(i => i.value === props.contratoChiclayo);
        setSelectedOptionChiclayo(currentChiclayo === undefined ? null : currentChiclayo);

        const currentIquitos = dataListaLocalesIquitos?.data.find(i => i.value === props.contratoIquitos);
        setSelectedOptionIquitos(currentIquitos === undefined ? null : currentIquitos);

        const currentSjl = dataListaLocalesSjl?.data.find(i => i.value === props.contratoSjl);
        setSelectedOptionSjl(currentSjl === undefined ? null : currentSjl);
        setShowUpdateModal(true);
    }, [dataListaLocalesArequipa, dataListaLocalesSantaAnita, dataListaLocalesChiclayo, dataListaLocalesIquitos, dataListaLocalesSjl]);

    const handleConfirmRecepcionModal = useCallback(() => {
        setIsFinishUpdateModal(false);
        setIsLoadingUpdateModal(true);

        const id = idContratoSimil;
        const arequipa = selectedOptionArequipa == null ? "" : selectedOptionArequipa.value;
        const chiclayo = selectedOptionChiclayo == null ? "" : selectedOptionChiclayo.value;
        const iquitos = selectedOptionIquitos == null ? "" : selectedOptionIquitos.value;
        const santaAnita = selectedOptionSantaAnita == null ? "" : selectedOptionSantaAnita.value;
        const sjl = selectedOptionSjl == null ? "" : selectedOptionSjl.value;

        if (idContratoSimil !== null && idContratoSimil >= 1) {
            queryClient.fetchQuery('EditMantenimientoTiendas',
                () => EditMantenimientoTiendasEx(id, arequipa, santaAnita, chiclayo, iquitos, sjl)
            ).then((result) => {
                if (result.success) {
                    refetch_data_data_contratos_similes();
                    setIsFinishUpdateModal(true);
                    setShowUpdateModal(false);
                } else {
                    setMessageErrorSave("ERRORRR!!!!!")
                }
            }).catch((err) => {
                setMessageErrorSave("ERRORRR!!!!!")
            }).finally(() => {
                setIsLoadingUpdateModal(false);
            });
        } else {
            queryClient.fetchQuery('SaveMantenimientoTiendas',
                () => SaveMantenimientoTiendasEx(arequipa, santaAnita, chiclayo, iquitos, sjl)
            ).then((result) => {
                if (result.success) {
                    refetch_data_data_contratos_similes();
                    setIsFinishUpdateModal(true);
                    setShowUpdateModal(false);
                } else {
                    setMessageErrorSave("ERRORRR!!!!!")
                }
            }).catch((err) => {
                setMessageErrorSave("ERRORRR!!!!!")
            }).finally(() => {
                setIsLoadingUpdateModal(false);
            });
        }
    }, [idContratoSimil, selectedOptionArequipa, selectedOptionChiclayo, selectedOptionIquitos, selectedOptionSantaAnita, selectedOptionSjl]);

    const handleCloseRecepcionModal = useCallback((params) => {
        setIsFinishUpdateModal(false);
        setIsLoadingUpdateModal(false);
        setMessageErrorSave("");
    }, []);

    const onFilterTextBoxChanged = useCallback(() => {
        gridApiRef.current.setQuickFilter(
            document.getElementById('filter-text-box').value
        );
    }, []);
    ///////////////////
    const [showModalDelete, setShowModalDelete] = useState(false);

    const handleShowModalDelete = useCallback((props) => {
        console.info(props, "propssssss delete");
        setIdContratoSimil(props.id);
        setShowModalDelete(true);
    }, [])



    // Cierre del Modal
    const onCloseModalDelete = () => {
        //console.info("--------- onCloseModalDelete");
    }

    const onConfirmModalDelete = () => {
        const id = idContratoSimil;
        queryClient.fetchQuery('DeleteContratoSimil',
            () => DeleteContratoSimil(id)
        ).then((result) => {
            if (result.success) {
                refetch_data_data_contratos_similes();
                setShowModalDelete(false);
            } else {
                setMessageErrorSave("ERRORRR!!!!!")
            }
        }).catch((err) => {
            setMessageErrorSave("ERRORRR!!!!!")
        }).finally(() => {
            setIsLoadingUpdateModal(false);
        });
    }
    //////////////////

    return (
        <>
            <CardEx title={'Contratos Símiles'}
                height={"700px"}
                isAvailableBreadcrumbs={true}
                isAvailableRefetch={true}
                isAvailableMaximized={true}
                onRefetch={async () => {
                    await refetch_data_data_contratos_similes();
                    cogoToast.success('Registros actualizado satisfactoriamente!', {
                        //hideAfter: 0,
                        heading: 'Contratos Símiles',
                        position: 'top-right'
                    });
                }}
            >
                <WrappedAgTable
                    {...agGridLista} >
                    <Button variant="primary" size="sm" onClick={handleNewContratosSimil}><i className="fi fi-rr-add"></i> Agregar</Button>
                </WrappedAgTable>
            </CardEx>

            <Confirm
                showModal={showModalDelete}
                setShowModal={setShowModalDelete}
                onClose={onCloseModalDelete}
                onConfirm={onConfirmModalDelete}
                message={'Seguro que desea <b><u>eliminar</u></b> el registro seleccionado?'}
            />

            <ConfirmWithLoader
                showModal={showUpdateModal}
                setShowModal={setShowUpdateModal}
                title={idContratoSimil == null ? "Agregar" : "Editar"}
                isLoading={isLoadingUpdateModal}
                isFinish={isFinishUpdateModal}
                textButton={"Guardar"}
                textButtonCancel={"Cerrar"}
                onConfirm={handleConfirmRecepcionModal}
                onClose={handleCloseRecepcionModal}
                hideContentInLoading={false}
                hideActionAfterConfirm={false}
            >
                <div className='container'>
                    <div className="row">
                        <form>
                            <div className="form-group mb-5">
                                <label for="exampleInputEmail1">Contrato Arequipa</label>
                                <Select
                                    defaultValue={selectedOptionArequipa}
                                    value={selectedOptionArequipa}
                                    onChange={setSelectedOptionArequipa}
                                    isClearable={true}
                                    isSearchable={true}
                                    options={dataListaLocalesArequipa?.data}
                                    className="custom-select"
                                />
                            </div>

                            <div className="form-group mb-5">
                                <label for="exampleInputEmail1">Contrato Santa Anita</label>
                                <Select
                                    defaultValue={selectedOptionSantaAnita}
                                    onChange={setSelectedOptionSantaAnita}
                                    isClearable={true}
                                    isSearchable={true}
                                    options={dataListaLocalesSantaAnita?.data}
                                    className="custom-select"
                                />
                            </div>

                            <div className="form-group mb-5">
                                <label for="exampleInputEmail1">Contrato Chiclayo</label>
                                <Select
                                    defaultValue={selectedOptionChiclayo}
                                    onChange={setSelectedOptionChiclayo}
                                    isClearable={true}
                                    isSearchable={true}
                                    options={dataListaLocalesChiclayo?.data}
                                    className="custom-select"
                                />
                            </div>

                            <div className="form-group mb-5">
                                <label for="exampleInputEmail1">Contrato Iquitos</label>
                                <Select
                                    defaultValue={selectedOptionIquitos}
                                    onChange={setSelectedOptionIquitos}
                                    isClearable={true}
                                    isSearchable={true}
                                    options={dataListaLocalesIquitos?.data}
                                    className="custom-select"
                                />
                            </div>
                            <div className="form-group mb-5">
                                <label for="exampleInputEmail1">Contrato San Juan de Lurigancho</label>
                                <Select
                                    defaultValue={selectedOptionSjl}
                                    onChange={setSelectedOptionSjl}
                                    isClearable={true}
                                    isSearchable={true}
                                    options={dataListaLocalesSjl?.data}
                                    className="custom-select"
                                />
                            </div>

                        </form>
                    </div>


                </div>
            </ConfirmWithLoader>
        </>
    )
}